import Callback from '../pages/callback';
import Login from '../pages/login';
import Logout from '../pages/logout';

export default [
  {
    path: '/auth',
    component: {
      render (c) {
        return c('router-view');
      },
    },
    children: [
      {
        path: 'callback',
        name: 'auth-callback',
        component: Callback,
        meta: { isPublic: true, isVuexOidcCallback: true },
      },
      {
        path: '',
        name: 'auth-login',
        component: Login,
        meta: { isPublic: true },
      },
      {
        path: 'logout',
        name: 'auth-logout',
        component: Logout,
        meta: { isPublic: true },
      },
    ],
  },
];
